/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { PhraseList } from 'src/luis/modules/features/types/PhraseList';
import { useModels } from 'src/luis/modules/models/useModels';

export type UsePhraseListsReturn = {
    phraseLists: PhraseList[];
    isLoaded: boolean;
    isLoading: boolean;
};

/**
 * A hook used to initialize the app phrase lists by doing the following.
 * 1) Fetches the current app phrase lists, intents and entities.
 * 2) Return the phrase lists and the loading state from the phrase list store house.
 */
export const usePhraseLists = (): UsePhraseListsReturn => {
    const { phraseListStores: phraseLists, isLoaded, isLoading } = useModels();

    return {
        phraseLists,
        isLoaded,
        isLoading
    };
};
